import { Box, HStack } from "@zenchef/styled-system/jsx";
import Button from "../Button/Button";
import { Dialog } from "@ark-ui/react";
import Icon from "../Icon/Icon";
import { Text } from "../typography/Text";
import { IconName } from "@zenchef/icomoon";
import { ReactNode } from "react";
import { cx } from "@zenchef/styled-system/css";
import { AromaButtonVariant } from "@zenchef/styled-system/recipes";
import { Action } from "../../utils/types";

interface HintProps {
  hint?: string;
  hintIcon?: IconName;
}

export interface FooterExposedProps {
  /**
   * Label to show and action to perform on click on primary button in the footer, if undefined, button wont be shown
   */
  primaryAction?: Action;
  /**
   * Label to show and action to perform on click on secondary button in the footer, if undefined, button wont be shown
   */
  secondaryAction?: Action;
  /**
   * Primary button color
   */
  primaryHierarchy?: AromaButtonVariant["hierarchy"];
  /**
   * Secondary button color
   */
  secondaryHierarchy?: AromaButtonVariant["hierarchy"];
  /**
   * Custom content element
   */
  content?: ReactNode;
  /**
   * custom className props to over the style
   */
  className?: string;
}
interface FooterInternalProps extends HintProps, FooterExposedProps {
  classes: { footer: string };
  fullWidth?: boolean;
  className?: string;
}

export default function Footer({
  classes,
  primaryAction,
  secondaryAction,
  hint,
  hintIcon,
  fullWidth,
  primaryHierarchy = "primary-bold",
  secondaryHierarchy = "secondary-subtle",
  content,
  className,
}: FooterInternalProps) {
  if (content) {
    return <Box className={cx(classes.footer, className)}>{content}</Box>;
  }

  return (
    <Box className={cx(classes.footer, className)}>
      {hint ? (
        <Dialog.Description asChild>
          <HStack marginRight="auto" gap="gap.1" pl="padding.2">
            <Icon name={hintIcon} fontSize="{sizes.2xs}" />
            <Text textStyle="paragraph.m.regular">{hint}</Text>
          </HStack>
        </Dialog.Description>
      ) : null}
      {secondaryAction ? (
        <Button
          {...secondaryAction}
          hierarchy={secondaryHierarchy}
          fullWidth={fullWidth}
          onClick={secondaryAction.onClick}
        >
          {secondaryAction.label}
        </Button>
      ) : null}
      {primaryAction ? (
        <Button
          {...primaryAction}
          hierarchy={primaryHierarchy}
          fullWidth={fullWidth}
          onClick={primaryAction.onClick}
        >
          {primaryAction.label}
        </Button>
      ) : null}
    </Box>
  );
}
